function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

export function getRatio(tilesWide, tilesHigh) {
    return tilesWide / tilesHigh;
}

export function buildInitialCrop(imageWidth, imageHeight, tilesWide, tilesHigh) {
    const targetRatio = getRatio(tilesWide, tilesHigh);
    const imageRatio = imageWidth / imageHeight;

    let width;
    let height;

    if (imageRatio > targetRatio) {
        height = imageHeight;
        width = Math.round(height * targetRatio);
    } else {
        width = imageWidth;
        height = Math.round(width / targetRatio);
    }

    const x = Math.round((imageWidth - width) / 2);
    const y = Math.round((imageHeight - height) / 2);

    return { x, y, width, height };
}

export function buildCropFromCenter(imageWidth, imageHeight, tilesWide, tilesHigh, currentCrop) {
    const nextCrop = buildInitialCrop(imageWidth, imageHeight, tilesWide, tilesHigh);
    if (!currentCrop) {
        return nextCrop;
    }

    const centerX = currentCrop.x + currentCrop.width / 2;
    const centerY = currentCrop.y + currentCrop.height / 2;
    const maxX = imageWidth - nextCrop.width;
    const maxY = imageHeight - nextCrop.height;
    const x = clamp(Math.round(centerX - nextCrop.width / 2), 0, maxX);
    const y = clamp(Math.round(centerY - nextCrop.height / 2), 0, maxY);

    return { ...nextCrop, x, y };
}

export function clampCrop(crop, imageWidth, imageHeight, tilesWide, tilesHigh) {
    const ratio = getRatio(tilesWide, tilesHigh);
    const width = clamp(Math.round(crop.width), 1, imageWidth);
    const height = clamp(Math.round(width / ratio), 1, imageHeight);
    const x = clamp(Math.round(crop.x), 0, imageWidth - width);
    const y = clamp(Math.round(crop.y), 0, imageHeight - height);
    return { x, y, width, height };
}

export function moveCrop(crop, deltaX, deltaY, imageWidth, imageHeight) {
    const x = clamp(crop.x + deltaX, 0, imageWidth - crop.width);
    const y = clamp(crop.y + deltaY, 0, imageHeight - crop.height);
    return { ...crop, x, y };
}

export function resizeCrop(crop, nextWidth, imageWidth, imageHeight, tilesWide, tilesHigh) {
    const ratio = getRatio(tilesWide, tilesHigh);
    const width = clamp(Math.round(nextWidth), 1, imageWidth);
    const height = clamp(Math.round(width / ratio), 1, imageHeight);

    return clampCrop(
        {
            ...crop,
            width,
            height
        },
        imageWidth,
        imageHeight,
        tilesWide,
        tilesHigh
    );
}
